@if (currentPath.back) {
    <div class="px-4 pt-4">
        <button class="flex gap-2" (click)="back()">
            <fa-icon [icon]="faChevronLeft"></fa-icon>
            ย้อนกลับ
        </button>
    </div>
    }